import { useContext, useState } from 'react';
import { Button } from '@mui/material';

import ApplicationsContext from 'Lib/contexts/ApplicationsContext';
import useNotify from 'Lib/hooks/useNotify';
import DeleteDialog from 'Lib/muiComponents/dialog/DeleteDialog';

export default function CancelButton({ id }) {
    const [showDialog, setShowDialog] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const { onDeleteApplication } = useContext(ApplicationsContext);
    const { toastError } = useNotify();

    const toggleDialog = () => setShowDialog(prev => !prev);

    const handleDelete = () => {
        setIsDeleting(true);
        onDeleteApplication(id)
            .then(() => toggleDialog())
            .catch(error => {
                toastError(error);
            })
            .finally(() => setIsDeleting(false));
    };

    return (
        <>
            <DeleteDialog open={showDialog} toggle={toggleDialog} isDeleting={isDeleting} onDelete={handleDelete}>
                Are you sure you want to delete this application?
            </DeleteDialog>
            <Button
                variant="outlined"
                sx={theme => ({
                    color: theme.palette.error.main,
                    borderColor: theme.palette.error.main,
                    '&:hover': { backgroundColor: theme.palette.common.lightred, borderColor: theme.palette.error.main }
                })}
                onClick={toggleDialog}
            >
                Cancel Application
            </Button>
        </>
    );
}
